import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Paper, Grid, Typography, Divider, Box } from '@mui/material';

import SBDropdown from '@Components/Dropdown';
import { AppDispatch, RootStateType } from '@Store';
import { vendorAccountType } from '@Reducers/AdminShipment/Type';
import { StageCarrier } from './Type';
import { addCarrierSettings, updateCarrierSettings } from '@Reducers/User/actions';
import { setCarrierSettings } from '@Reducers/User';
import SbButton from '@Components/Button';

interface propsTypes {
  onClose: () => void;
  isEditable: boolean;
}

const validationSchema = Yup.object({
  accountNo: Yup.array().required('Account number is required'),
});

const StageInformation = (props: propsTypes) => {
  const { isEditable, onClose } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { vendersAccount } = useSelector((state: RootStateType) => state.adminShipment);
  const { carrierSetting, userDataById } = useSelector((state: RootStateType) => state.user);

  const { values, setFieldValue, errors, handleSubmit } = useFormik<StageCarrier>({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema,
    initialValues: {
      ...carrierSetting.stage,
    },
    onSubmit(values) {
      if (userDataById?._id) {
        if (carrierSetting.stage._id) {
          dispatch(updateCarrierSettings({ ...carrierSetting.stage, ...values }));
        } else {
          dispatch(addCarrierSettings({ ...carrierSetting.stage, ...values }));
        }
      } else {
        dispatch(setCarrierSettings({ values, carrierType: 'stage' }));
      }

      onClose();
    },
  });

  const accountOptions = useMemo(
    () =>
      vendersAccount?.map((item: vendorAccountType) => ({
        value: `${item.accountNo}-${item._id}`,
        display: item.name,
      })),
    [vendersAccount],
  );

  return (
    <Paper variant="outlined" sx={{ my: '2rem', p: '2rem' }}>
      <Grid container item spacing={15}>
        <Grid item xs={12} md={15}>
          <Grid container item mb={3}>
            <Grid item xs={12} md={6}>
              <Typography className="font-medium l-text pb-3">Allied Information</Typography>{' '}
            </Grid>
          </Grid>

          <Box
            sx={{
              position: 'relative',
              height: '100px',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
              }}
            >
              <SBDropdown
                disabled={!isEditable}
                id="accountNo"
                label="Allied Account"
                required
                multiple
                placeholder="Select"
                name="accountNo"
                value={values?.accountNo.map(item => item.value)}
                options={accountOptions}
                onChange={(_, selectedObj) => setFieldValue('accountNo', selectedObj)}
                error={Array.isArray(errors.accountNo) ? errors.accountNo.join(', ') : errors.accountNo}
              />
            </Box>
          </Box>
        </Grid>
        <Divider className="mt-3 mb-3" />
        <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
          <Grid container item sx={{ gap: '1rem' }}>
            <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
              <SbButton
                type="submit"
                disabled={!isEditable}
                variant="contained"
                sx={{ borderRadius: `4px !important` }}
                className="w-full"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Save
              </SbButton>
            </Grid>
            {onClose && (
              <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                <SbButton
                  type="button"
                  sx={{ borderRadius: `4px !important` }}
                  className="w-full"
                  variant="outlined"
                  onClick={onClose}
                >
                  Cancel
                </SbButton>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default StageInformation;
